import {reportBiError} from '../statistics/bi';
import {BI_ERRORS} from './errors';

export function installUnhandled() {
  const original = window.onunhandledrejection;
  window.onunhandledrejection = function (...args: any) {
    if (original) {
      try {
        original(...args);
      } catch (ex) {
        console.error(ex);
      }
    }

    const event: PromiseRejectionEvent = args[0];
    let message;
    try {
      message =
        event && 'reason' in event && event.reason && 'message' in event.reason
          ? event.reason.message
          : 'unknown reason';
      message = message.slice(0, 600);
    } catch (e) {
      console.error(e);
    }
    reportBiError(BI_ERRORS.widget.unhandled.rejection, {p1: message});
  };
}
